import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'PRIMARY_MEDIA_PROVIDER_GET',
  GET_SUCCESS: 'PRIMARY_MEDIA_PROVIDER_GET_SUCCESS',
  GET_FAILURE: 'PRIMARY_MEDIA_PROVIDER_GET_FAILURE',
};

export const get = actions.get(
  teacherClassroomId => `${BASE_URL}/av/primary-media-provider/${teacherClassroomId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
